import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';
import { GetObjectResponse } from './global/responses/get-object-response';
import { ServerVersion } from './global/responses/server-version';
import { ExecuteObservable } from './global/execute-observable';
import { Logger } from './global/logger';

/**
 * Provides ability to get version information from the server.
 */
@Injectable()
export class VersionService {

	constructor(private _HttpClient: HttpClient) { }

	/**
	 * Checks the server (API) version number and if it does not match the client's version, reloads the page
	 */
	public ReloadIfClientUpdateIsAvailable(): void {
		this.GetServerVersion().then((serverVersion: ServerVersion) => {
			Logger.Log('Client version: ' + environment.Version);
			Logger.Log('Server version: ' + serverVersion.Version);
			if (environment.Version != serverVersion.Version) {
				window.location.reload();
			}
		}).catch(() => {
			Logger.Log('Unable to retrieve server version.')
		});
	}

	/**
	 * Gets the version of the server (the web API backend)
	 *
	 * @returns A promise which supplies the server version.
	 */
	private GetServerVersion(): Promise<ServerVersion> {
		let observable: Observable<GetObjectResponse<ServerVersion>>;
		const url = `${environment.WebServiceUrl}Version`;

		observable = this._HttpClient.get<GetObjectResponse<ServerVersion>>(url, { withCredentials: true });

		return ExecuteObservable.ExecuteQuery<ServerVersion>(observable, 'VersionService.GetServerVersion');
	}
}
